import DataAsesmenRalan from "@/services/DataAsesmenRalan";
import { IdentitasPasien } from "@/types";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";
// import DataAssesmenPenunjang from "@/services/DataAssesmenPenunjang";

// interface AssesmenRalan {
//   id: string;
//   unit_id: number;
//   user_id: number;
//   catatan: string;
// }

interface StatusAssesmenRalan {
  status: string;
  message: string;
}

@Module({ store, dynamic: true, name: "storeAssesmenRalan" })
class StoreAssesmenRalan extends VuexModule {
  // assesmenRalan = {} as AssesmenRalan;
  status = {} as StatusAssesmenRalan;
  asesmenAwal = {};

  // @Mutation SET_ASSESMEN_RALAN(assesmenRalan: AssesmenRalan) {
  //   this.assesmenRalan = assesmenRalan;
  // }

  @Mutation SET_ASSESMEN_AWAL(asesmenAwal: {}) {
    this.asesmenAwal = asesmenAwal;
  }

  @Mutation SET_CHECK_ASSESMEN_RALAN(status: StatusAssesmenRalan) {
    this.status = status;
  }

  // @Action actAsesmenRalan_on_reg(param) {
  //   const dt = DataAsesmenRalan.getDataAsesmenRalan(param["unit_id"], param["reg"]);
  //   appModule.setLoading(true);
  //   dt.then(dt => {
  //     appModule.setLoading(false);
  //     const detail = dt.data
  //     this.SET_ASSESMEN_RALAN(detail)
  //   });
  // }

  @Action({ rawError: true })
  actAsesmenAwal(param) {
    const dt = DataAsesmenRalan.getDataAsesmenAwalRalan(
      param["unit_id"],
      param["reg"]
    );
    appModule.setLoading(true);
    dt.then(dt => {
      console.log("store", dt.data);
      appModule.setLoading(false);
      const detail = dt.data;
      this.SET_ASSESMEN_AWAL(detail);
    });
  }

  @Action({ rawError: true })
  act_check_assesmen(param) {
    const dt = DataAsesmenRalan.getDataStatusAsesmenRalan(
      param.unit_id,
      param.rm,
      param.reg
    );
    // appModule.setLoading(true);
    dt.then(dt => {
      // appModule.setLoading(false);
      // const detail = dt.data
      // console.log(dt)
      const sts = dt;
      this.SET_CHECK_ASSESMEN_RALAN(sts);
    });
  }

  @Action({ rawError: true })
  reset() {
    this.SET_ASSESMEN_AWAL(null);
  }
}

export const storeAssesmenRalan = getModule(StoreAssesmenRalan);
